import { StrapiImage } from './MediaProps';
import { BlogComponent } from '../util/RenderBlogPosts/RenderBlogPosts';
import { SeoMetadata } from '../util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export enum ResourceTypes {
    ALL = 'All',
    ARTICLES = 'ARTICLES',
    NEWS = 'NEWS',
    EVENTS = 'EVENTS',
    BRANDING = 'BRANDING',
    WEBSITES = 'WEBSITE',
    CUSTOMER_STORIES = 'CUSTOMER_STORIES',
    OUR_WORK = 'OUR_WORK',
}

export interface ResourceCategory {
    id: number;
    key: string;
    name: string;
    count: number;
}

export interface Resource {
    heading: string;
    ingress: string;
    mainImage?: StrapiImage;
    authorName: string;
    publishedAt: string;
    seoUrl: string;
    tag?: ResourceTypes;
    content?: Array<BlogComponent>;
    seo?: SeoMetadata;
    resource_category: ResourceCategory;
}
